import React from 'react';
import { Box, Typography, useMediaQuery } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import CustomSwitch from '../CustomSwitch';

const AppHeader = () => {
  const navigate = useNavigate();
  const location = useLocation();
  // レスポンシブ判定: スマホ(～767px) / タブレット(768～1023px) / PC(1024px～)
  const isMobile = useMediaQuery('(max-width:767px)');
  const isTablet = useMediaQuery('(min-width:768px) and (max-width:1023px)');

  const handleViewChange = (event) => {
    const newPath = event.target.checked ? '/memo' : '/';
    navigate(newPath);
  };

  const title = location.pathname === '/memo'
    ? '取材メモ管理'
    : '取材スケジュール管理';

  const headerColor = location.pathname === '/memo' ? '#388e3c' : '#1976d2';

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        maxWidth: 1920,
        width: '100%',
        mx: 'auto',
        p: 2,
        bgcolor: headerColor,
        color: '#ffffff',
        position: 'relative',
      }}
    >
      <Typography
        variant="h6"
        sx={{
          fontSize: (isMobile || isTablet) ? '0.9rem' : '1.25rem',
        }}
      >
        {title}
      </Typography>

      <Box sx={{ mr: (isMobile || isTablet) ? 6 : 0 }}>
        <CustomSwitch
          checked={location.pathname === '/memo'}
          onChange={handleViewChange}
        />
      </Box>
    </Box>
  );
};

export default AppHeader;